
import { createApiClient } from 'Network/ApiClient';
  
  export const NewNetworkAxiosInstance = createApiClient('Networks/');


